import { formatMonthName } from '../../utils';
import { getExtrapolatedFieldValue, getRowMonthKey } from '../../utils/clubGrowthMetrics';
import { ComparisonStatus, MetricConfig, PulseRow, TOLERANCE_PP } from './marketPulseConstants';
export const rowKey = (d: PulseRow): string => getRowMonthKey(d);

export function kpiPeriodGrowth(
  endRow: PulseRow | null,
  startRow: PulseRow | null,
  field: MetricConfig['sourceField'],
  sourceData: PulseRow[],
  extrapolate: boolean
): number | null {
  if (!endRow || !startRow) return null;
  const start = getExtrapolatedFieldValue(startRow, field, sourceData, extrapolate);
  const end = getExtrapolatedFieldValue(endRow, field, sourceData, extrapolate);
  return start !== 0 ? ((end - start) / start) * 100 : null;
}

export const getStatus = (diff: number | null): ComparisonStatus => {
  if (diff === null || Number.isNaN(diff)) return 'equal';
  if (diff > TOLERANCE_PP) return 'better';
  if (diff < -TOLERANCE_PP) return 'worse';
  return 'equal';
};

export const STATUS_CONFIG: Record<
  ComparisonStatus,
  { label: string; bg: string; color: string; border: string; icon: string }
> = {
  better: {
    label: 'جلوتر از بازار',
    bg: 'var(--status-success-bg)',
    color: 'var(--status-success)',
    border: 'var(--status-success)',
    icon: '↗',
  },
  worse: {
    label: 'عقب‌تر از بازار',
    bg: 'var(--status-error-bg)',
    color: 'var(--status-error)',
    border: 'var(--status-error)',
    icon: '↘',
  },
  equal: {
    label: 'هم‌تراز بازار',
    bg: 'var(--bg-tertiary)',
    color: 'var(--text-secondary)',
    border: 'var(--border-primary)',
    icon: '→',
  },
};

export const fmtPct = (v: number | null): string => {
  if (v === null || Number.isNaN(v)) return '—';
  const prefix = v > 0 ? '+' : '';
  return `${prefix}${v.toFixed(2)}%`;
};

/** درصد گردشده برای کارت KPI (بدون اعشار) */
export const fmtPctCompact = (v: number | null): string => {
  if (v === null || Number.isNaN(v)) return '—';
  const prefix = v > 0 ? '+' : '';
  return `${prefix}${Math.round(v)}%`;
};

export const fmtUnit = (v: number | null): string => {
  if (v === null || Number.isNaN(v)) return '—';
  const prefix = v > 0 ? '+' : '';
  return `${prefix}${v.toFixed(2)}`;
};

export const fmtDiff = (v: number | null): string => {
  const unit = fmtUnit(v);
  return unit === '—' ? unit : `${unit}%`;
};

export const formatPulseMonthLabel = (row: PulseRow): string => {
  const monthName = formatMonthName(row.month) || row.month;
  return row.year ? `${monthName} ${row.year}` : monthName;
};
